/* Screen 1 - Review Policy Plan */

import { useState } from "react";
import { useSelector } from "react-redux";
import goldIcon from "../../../../assets/images/Gold.svg";
import platiniumIcon from "../../../../assets/images/Platinium.svg";
import silverIcon from "../../../../assets/images/Silver.svg";
import TitleDescription from "../../../../components/newMotorPolicy/titleDescription/titleDescription";
import ViewSummaryPopup from "../../../../components/newMotorPolicy/veiwSummaryPopup/viewSummaryPopup";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import useTravelRenewalFlow from "../../../../hooks/useTravelRenewalFlow";
import { PolicyViewResponse } from "../../../../redux/features/motor/getQuoteSlice";
import TravelRenewalLayout from "../components/TravelRenewalLayout";

// Plan code to display info mapping
// Old codes (SILVER/GO/PL) kept for existing policies, new codes for new travel plans
const planDisplayMap = {
  SILVER: {
    image: silverIcon,
    name: "Silver",
    name_ar: "الفضية",
  },
  GO: {
    image: goldIcon,
    name: "Gold",
    name_ar: "الذهبية",
  },
  PL: {
    image: platiniumIcon,
    name: "Platinum",
    name_ar: "البلاتينية",
  },
  SCHENGENB: {
    image: silverIcon,
    name: "Schengen",
    name_ar: "شنغن",
  },
  WLEXB: {
    image: goldIcon,
    name: "Worldwide (Excl. USA & Canada)",
    name_ar: "جميع دول العالم (باستثناء أمريكا وكندا)",
  },
  WLB: {
    image: platiniumIcon,
    name: "Worldwide",
    name_ar: "جميع دول العالم",
  },
};

const ReviewPolicyPlanPage = ({ handleNavigationToRenewalHub }) => {
  const translate = useLanguageTranslate();
  const policyInfo = useSelector(PolicyViewResponse);
  const { goToStep } = useTravelRenewalFlow();

  // State for summary modal
  const [showSummaryModal, setShowSummaryModal] = useState(false);

  // Get current plan info
  const currentPlanCode = policyInfo?.PolicyHeader?.PlanCode;
  const currentPlanInfo = planDisplayMap[currentPlanCode] || planDisplayMap.SILVER;

  // Premium API not available yet — do not use view API premium values
  const policyHeader = policyInfo?.PolicyHeader || {};
  const quoteNumber = policyHeader.QuoteNumber || policyHeader.PolicyNumber || "";

  // Handle "Change your plan" click - go to step 1 (Select New Plan)
  const handleChangePlanClick = () => {
    goToStep(1); // Go to Select Plan step
  };

  // Handle continue click - skip to step 2 (Enhance Coverage)
  const handleContinueClick = () => {
    goToStep(2); // Skip to Enhance Coverage step
  };

  // Handle back click - go back to renewal hub
  const handleBackClick = () => {
    handleNavigationToRenewalHub();
  };

  // Handle show summary modal
  const handleShowSummary = () => {
    setShowSummaryModal(true);
  };

  return (
    <>
    <TravelRenewalLayout
      is_hide_back_btn={false}
      show_close_btn={false}
      isFirstStep={false}
      backClickHandler={handleBackClick}
      btn_onClick={handleContinueClick}
      btn_disabled={false}
      show_summary={false}
      onShowSummary={handleShowSummary}
      btn_label={translate("Continue", "التالي")}
    >
      <div className="reviewPolicyPlan p-4 pt-0 w-[33%] max-350:w-[100%] max767:w-[100%] ipad:w-[55%] mx-auto max767:p-5 max767:pt-6">
        <TitleDescription
          title={translate("Review Your Policy Plan", "راجع خطة وثيقتك")}
          description={translate(
            "You can either continue with your current plan or choose to downgrade.",
            "يمكنك إما الاستمرار بخطتك الحالية أو اختيار التخفيض."
          )}
          className="mb-6"
        />

        {/* Current Plan Details Card */}
        <div className="bg-[#F6F8F9] rounded-2xl p-6 mb-6">
          {/* Current Plan Details Header */}
          <h4
            className="mb-4 text-base font-semibold text-[#1A2024]"
          >
            {translate("Current Plan Details", "تفاصيل الخطة الحالية")}
          </h4>

          {/* Plan Icon and Name */}
          <div className="flex items-center gap-4">
            <img
              src={currentPlanInfo.image}
              alt={translate(currentPlanInfo.name, currentPlanInfo.name_ar)}
              className="w-12 h-12 object-contain"
            />
            <h3 className="text-[#1A2024] text-lg font-semibold">
              {translate(currentPlanInfo.name, currentPlanInfo.name_ar)}
            </h3>
          </div>
        </div>

        {/* Change Plan Button with underline */}
        <button
          onClick={handleChangePlanClick}
          className="w-full text-center py-3"
        >
          <span
            className="underline text-base font-bold text-[#00384D]"
          >
            {translate("Change your plan", "تغيير خطتك")}
          </span>
        </button>
      </div>
    </TravelRenewalLayout>

    {/* Summary Modal */}
    <ViewSummaryPopup
      show={showSummaryModal}
      setShow={setShowSummaryModal}
      passedFrom="TravelRenewal"
    />
    </>
  );
};

export default ReviewPolicyPlanPage;
